import { TemplateRef } from '@angular/core';
import { Params } from '@angular/router';

export interface Crumb {
  type: 'default' | 'template';
  path?: string;
  label?: string;
  queryParams?: Params | null;
  template?: TemplateRef<unknown>;
}
